import { HttpStatusCode } from "axios";
import { useCallback, useState } from "react";
import Toast from "../components/general/Toast";
import { globalAxiosInstance } from "../_apiConfig/globalAxios";

export default function useFetcher() {
  const notify = Toast();

  const initialResponse = {
    data: [],
    meta: {},
    success: false,
    statusCode: HttpStatusCode.Ok,
  };

  const [data, setData] = useState(initialResponse);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetch = useCallback(async function (config) {
    setLoading(true);
    setError(null);

    try {
      const response = await globalAxiosInstance({
        ...config,
        baseURL: process.env.REACT_APP_API_URL,
      });

      if (response instanceof Blob) {
        setData({ ...initialResponse, data: response, success: true });
        return response;
      }

      if (response.statusCode === HttpStatusCode.Created) {
        return response;
      }
      setData(response);
      return response;
    } catch (err) {
      const axiosError = err;

      if (axiosError.response?.status === HttpStatusCode.Forbidden) {
        setError("Permission not Allowed");
        notify("Permission not Allowed", "error");
      } else {
        const errorMessage = axiosError.message || "Something went wrong";
        setError(errorMessage);

        return axiosError.response?.data;
      }
    } finally {
      setLoading(false);
    }
  }, []);

  return { data, error, loading, fetch };
}

/**
Component
   │
   │ fetch({
   │   method: 'GET',
   │   url: '/users'
   │ })
   ↓
useFetcher
   │
   ├── loading = true
   ├── error = null
   │
   ↓
globalAxiosInstance
   │
   ↓
Backend API
   │
   ├─────────────── Success ────────────────┐
   │                                        │
   │                                  response
   │                                        │
   │                         ┌──────────────┴─────────────┐
   │                         │                            │
   │                       Blob                      Normal JSON
   │                         │                            │
   │                    setData()                    setData()
   │                                                      │
   │                                                      ↓
   │                                                     data
   │
   └─────────────── Error ───────────────────┐
                                             │
                                           AxiosError
                                             │
                                ┌────────────┴────────────┐
                                │                         │
                              403                    Other error
                                │                         │
                         setError + Toast          setError + Toast
                                │                         │
                                └────────────┬────────────┘
                                             ↓
                                      return error data

Finally:
    loading = false
*/